import styled from "styled-components";

const ForgetPassword = styled.div`
  display: flex;
  justify-content: flex-end;
  margin: 30px 0 40px;
`;

export default ForgetPassword;
